
import { getTableColumnsLocalStore, getTransmferFields, mergeColumns, pageInfoStore, seriesNumberField } from '../utils/utilsTable';
// import { defaultWidthColumn, useMemoWidthColumns } from '../hooks/useMemoWidthColumns';
import {  QuickBiReportDataResponse } from '../../services/bi/bi';
import { CustomReportConfig, SlideModalType, TableModule } from '@/component/common/report/reportConfigModel';
import { UseGetDataResultReturnType, useGetData } from '@/component/PageComponent/hooks/requst';
import React from 'react';
import { TableFieldSet, TableFieldSetColumn } from '../../TableFieldSet/TableFieldSet';
import { TemplateDataModel } from '@/component/Template/TemplateDataModel';
import { CreateImportExportTaskParams } from '@/component/Export/services/task';
import { serviceQuickBiReportTemplate } from '@/component/Template/services/template';
import { isError } from '@/component/common/error';
import _ from 'lodash';
import { Export } from '@/component/Export/ExportModal';
// import { settingBase64 } from '../../assets/settingBase64';
import { DhbFooterProps, ExportQuanlityType } from '@/component/PageComponent/PageComponent';
import { Checkbox, Col, ConfigProvider, Flex, Row, Select, Dropdown, Menu, Button, Modal, Pagination, Spin, Tooltip, message } from 'antd';
import { TeamOutlined, UpOutlined,SettingOutlined } from '@ant-design/icons';
import { formatNumberByTemplate, numberThousandSeparatorByValueType } from '../../share/numberFormat';
import { TableResize } from '@/component/PageComponent/Table/TableResize';
import styled from 'styled-components';
import { EllipsisTooltip } from '@/component/common/EllipsisTooltip';
import { ReportConfig } from '@/component/common/report/report';
import { CountType } from '@/component/ReportCommon/share/params';
import { ReportParams } from "@/component/common/report/report"
import { requestLoading } from '@/hooks/hooksPc/useRequestLoadingPc';
import { PostMessageType, postMessageToParent } from '../../utils/postMessageToParent';
import useQuickBiTemplate from '@/component/Template/hooks/useQuickBiTemplate';


const TableView = styled.div`
  /* flex:1;
  overflow: hidden; */
  .ant-table-thead{
    th{
      position: relative;
    }
    .react-resizable{
      position: absolute;
      top: 0;
      height: 0;
      left: 0;
    }
  }
  .ant-table-thead{
    &:hover{
      .react-resizable-handle{
        display: block;
      }
    }
    .react-resizable-handle{
        display: block;
      }
  }
  .ant-table-wrapper td.ant-table-column-sort{
    background-color: #fff;
  }
  .ant-table-wrapper .ant-table-thead th.ant-table-column-sort{
    background-color: #f5f5f5;
  }
  .react-resizable-handle {
    display: none;
    position: absolute;
    right: 0px;
    top:12px;
    z-index: 1;
    width: 10px;
    height: 30px;
    cursor: col-resize;
    border-right: 1px solid rgba(204,204,204,0.8);
  }
`



const DhbFooter = (props: DhbFooterProps) => {
  const {
    selectedRowKeys = [],
    onChange,
    dataSource = [],
    isAllSelect,
    total = 0,
    pageInfo,
    toggleSelectRowKeys,
  } = props;
  const { page = 1, pageSize = 10 } = pageInfo;
  return (
    <div style={{ padding: '10px',borderTop:'1px solid #f0f0f0',background:'#fff' }}>
      <Row>
        <Col span={8}>
          <Dropdown placement="topLeft"
            menu={{
              items: [
                { label: "导出本页", key: "page", },
                { label: "导出全部", key: "all", },
              ].map(item => ({ label: <div onClick={() => props.onExport && props.onExport(item.key as ExportQuanlityType)} >{item.label}</div>, key: item.key }))
            }}
          >
            <Button>
              批量导出
              <UpOutlined />
            </Button>
          </Dropdown>
        </Col>
        <Col span={16}>
          <Pagination
            showTotal={(total) => `共计${total}条`}
            style={{ textAlign: 'right' }}
            defaultPageSize={pageSize}
            total={total}
            current={page}
            totalBoundaryShowSizeChanger={11}
            onChange={(page, pageSize) => onChange({ page: page, pageSize })}
            // onShowSizeChange={(current, pageSize) =>
            //   onChange({ page: 1, pageSize })
            // }
            showQuickJumper={false}
          />
        </Col>
      </Row>
    </div>
  );
};




interface CustomTableProps {
  reportTableData?:Array<Record<string,string|number>>,
  reportConfig: ReportConfig,
  source: string // 数据源
  moduleItem: TableModule
  params: ReportParams,
  count?: number,
  dataHandler: UseGetDataResultReturnType<ReportParams>
  loading?: boolean
}



export function BaseTable(props: CustomTableProps) {
  const { reportConfig, moduleItem, params ,dataHandler ,reportTableData , count,source } = props
  const [template, setTemplate] = React.useState<TemplateDataModel>({})
  const [columns, setColumns] = React.useState<TableFieldSetColumn[]>([])
  // const [total, setTotal] = React.useState(0)
  const [exportVisible,setExportVisible] = React.useState(false)
  const [taskData, setExportTaskData  ] = React.useState<{exportParams:CreateImportExportTaskParams['params'],templateFields: string }>({exportParams:{},templateFields:''})
  const [tableFieldSetVisible,setTableFieldVisible] = React.useState(false)
  let total = count || 0
  const showSeriesNumber = true
  const transformer_fields  = React.useMemo(()=>{
    return getTransmferFields(props.reportConfig)
  },[props.reportConfig])

  // 使用抽象后的模板 Hook
  const { template: tpl } = useQuickBiTemplate(reportConfig?.config?.slug, moduleItem?.template_code)

  // 模板变更后构建列
  React.useEffect(() => {
    if (!tpl || !tpl.fields) return;
    setTemplate(tpl)
    const columns = mergeColumns(tpl, {
      report_name: reportConfig.config.slug,
      accounts_id: reportConfig.accounts_id,
      showSeriesNumber: true,
      defaultDisplayFields: moduleItem.defaultDisplayFields
    })
    setColumns(columns)
  }, [tpl, reportConfig, moduleItem])

  const onExport = (key: ExportQuanlityType) => {
    /**
     * 导出全部，pageSize改为100，
     * 导出选中，本页，pageSize 就是当前pageSize大小，如果pageSize超过整个数据total，那么pageSize就为total
     */
    let exportParams:CreateImportExportTaskParams['params']&ReportParams = {...params}
    let expect = total
    let pageInfo = {
      ...dataHandler.pageInfo,
    }
    if(key == 'page'){
      expect = reportTableData?.length || 0;
      exportParams.export_page = dataHandler.pageInfo.page
      if(pageInfo.pageSize > expect){
        pageInfo.pageSize = expect
      }
    }
    if(key == ExportQuanlityType.all){
      pageInfo.pageSize = 100
    }

    if(expect == 0){
      message.error('无数据导出')
      return
    }
    exportParams = {
      ...exportParams,
      ...pageInfo,
      expect: expect.toString(),
      count: 1,
      source: source,
      report: reportConfig.config.slug,
    }
    let templateFieldsObj = _.keyBy(template.fields,'code')
    let templateFields = columns.filter(item => item.show =='T').map(item => {
      let valueType = templateFieldsObj[item.dataIndex] && templateFieldsObj[item.dataIndex].valueType
      return {
        code: item.dataIndex,
        valueType: valueType,
      }
    })
    setExportVisible(true)
    setExportTaskData({
      exportParams:exportParams,
      templateFields:JSON.stringify(templateFields),
    })
  }
  
  let data = reportTableData || []
  let templateFieldsObj = _.keyBy(template.fields,'code');
  data = formatNumberByTemplate(data,templateFieldsObj)
  // data = data.map((_item,index) =>{
  //   let item = {..._item}
  //   Object.keys(item).forEach(key=>{
  //     if(templateFieldsObj[key]){
  //       let valueType = templateFieldsObj[key].valueType
  //       item[key]= numberThousandSeparatorByValueType(item[key],valueType)
  //     }
  //   })
  //   // item['empty'] = ' '
  //   return {
  //     ...item,
  //   }
  // })
 
  const getCompanyTableColumnsLocalStore = ()=>getTableColumnsLocalStore(reportConfig.accounts_id)
  const reportSlug = reportConfig.config.slug
  let tableColumns = columns.filter(item => item.show  == 'T' && !item.isSerial)
 
  tableColumns.length && tableColumns.unshift({
    // title: <Tooltip placement="top" title="可列配置"><Icon className="pointer" type="setting" /></Tooltip>,
    title: <SettingOutlined className="pointer" style={{cursor:'pointer'}}/>,
    width: 60,
    dataIndex: 'sequence',
    align:'center',
    onHeaderCell: () => {
      return {
        onClick: () => setTableFieldVisible(true)
      }
    },
    render: (text, record, index) => {
      // return <div style={{height:'60px'}}>
      return <div >
        {index + 1}
      </div>
    }
  })
  tableColumns = tableColumns.map((_item,index)=>{
    let item = {..._item}
    if(index <= 1){
      item.fixed = 'left'
    }
    if(item.ellipsis){
      item.ellipsis = {
        showTitle: false,
      }
      // item.render = (text)=><Tooltip placement="topLeft" title={text}>
      //   {text}
      // </Tooltip>
      item.render = (text)=><EllipsisTooltip text={text} width={item.width ? Number(item.width):undefined}/>
    }
    let isSort = moduleItem.sortField?.includes(item.dataIndex)
    if(isSort){
      item.sorter =  {
        multiple: index
      }
    }
    let currentSort = params.sortParams?.find(sortItem => sortItem.dataIndex == item.dataIndex )
    if(currentSort && currentSort.order){
      item.sortOrder = currentSort.order
    }else{
      delete item.sortOrder
    }
    let link_fields = moduleItem.link_fields || []
    if(link_fields.length){
      let currentLinkField = link_fields.find(linkField => linkField.field == item.dataIndex);
      if(currentLinkField){
        item.render = (text,record)=>{
          const onClick = ()=>{
            let jumpUrl = record[currentLinkField!.urlField];
            if(!jumpUrl){
              message.error('获取跳转链接失败')
              return
            }
            postMessageToParent({
              type: PostMessageType.navigate,
              data:{
                url: jumpUrl,
                name: currentLinkField!.name
              }
            })
          }
          return <div style={{cursor:'pointer',color:"#428bca"}} onClick={()=>onClick()} >{text}</div>
        }
      }
    }
    addSlideModal()
    function addSlideModal(){
      if(moduleItem.slide_modal && moduleItem.slide_modal.length){
        let currentSlideModal = moduleItem.slide_modal.find(slideModal => slideModal.field == item.dataIndex);
        if(currentSlideModal){
          item.render = (text,record)=>{
            const onClick = ()=>{
              let params:Record<string,any> = {}
              const paramsKeysMap:Record<string,any> = currentSlideModal?.paramsKeysMap || {}
              Object.keys(paramsKeysMap).forEach((key,index)=>{
                let valueKey = paramsKeysMap[key]
                params[key] = record[valueKey]
              })
              postMessageToParent({
                type: PostMessageType.openSlideModal,
                data:{
                  modalType: currentSlideModal!.modalType,
                  params: params
                }
              })
            }
            return <div style={{cursor:'pointer',color:"#428bca"}} onClick={()=>onClick()} >{text}</div>
          }
        }
      }
    }
    return item
  })
  return <TableView style={{flex:1,display:'flex',flexDirection:'column',overflow:'hidden',minHeight:'550px',background:'#fff'}}>
    {exportVisible && <Export 
    onClose={()=>setExportVisible(false)}
    createTaskData={{
      params: {
        ...taskData.exportParams,
        transformer_fields: transformer_fields,
      },
      expect: total.toString(),
      templateCode: moduleItem.template_code,
      templateFields:  taskData.templateFields,
    }} />}
    {/* <div style={{ height: '300px' }}> */}
    <TableFieldSet
      visible={ tableFieldSetVisible }
      columns={columns.filter(item => item.dataIndex != 'sequence' && !item.isSerial)}
      onRest={()=>{
        const tableColumnsLocalStore = getCompanyTableColumnsLocalStore()
        tableColumnsLocalStore.save(reportSlug,'')
        let columns = mergeColumns(template,{report_name:reportSlug,accounts_id:reportConfig.accounts_id,showSeriesNumber,defaultDisplayFields: moduleItem.defaultDisplayFields})
        setColumns(columns)
        setTableFieldVisible(false)
      }}
      onSure={(columns)=>{
        const tableColumnsLocalStore = getCompanyTableColumnsLocalStore()
        tableColumnsLocalStore.save(reportSlug,columns)
        setColumns(columns)
        setTableFieldVisible(false)
      }}
      onClose={()=>{
        setTableFieldVisible(false)
      }}
    />
    <TableResize
        loading={ props.loading }
        columns={ tableColumns }
        dataSource={data.map((item,index) =>({...item,key:index}))}
        onChange={(pagination,filters,sorter)=>{
          
          if(Array.isArray(sorter)){
            let oldSortParamsObj = _.keyBy(params.sortParams,'dataIndex');
            let current = sorter.find(item => {
              const { column } = item
              let dataIndex = column?.dataIndex
              if (dataIndex) {
                let old = oldSortParamsObj[dataIndex.toString()];
                return !old || old.order != item.order
              }
            })
            if (current) {
              const { field, order } = current
              dataHandler.setParams({ ...params, sortParams: [{ dataIndex: field as string, order }],count: CountType.isRequestTable })
            }
          } else {
            const { field, order } = sorter
            dataHandler.setParams({...params,sortParams: [{dataIndex: field as string,order}],count: CountType.isRequestTable})
          }
          console.log(sorter)
        }}
        pagination={false}
        onColumnChange={(tableColumns)=>{
          tableColumns = tableColumns || []
          const tableColumnsLocalStore = getCompanyTableColumnsLocalStore()
          let tableColumnsObj = _.keyBy(tableColumns,'dataIndex')
          let newColumns = columns.map(item=>{
            let tableColumn = tableColumnsObj[item.dataIndex]
            if(tableColumn){
              item.width = tableColumn.width
            }
            return item
          })
          tableColumnsLocalStore.save(reportSlug,newColumns)
          setColumns(newColumns)
        }}
      />
    <DhbFooter
      onChange={(pageInfo) => {
        console.log(pageInfo,"pageInfo");
        
        // dataHandler.setParams({...dataHandler.params,count: CountType.isRequestTable})
        // dataHandler.setPageInfo(pageInfo)
        dataHandler.setParamsAndPageInfo({...dataHandler.params,count: CountType.isRequestTable},pageInfo)
        // dataHandler.setParams({...dataHandler.params,count:0})
        pageInfoStore.save(pageInfo.pageSize.toString())
        // dataHandler.setParams({...dataHandler.params,...pageInfo})

      }}
      onExport={onExport}
      total={total}
      pageInfo={dataHandler.pageInfo}
    />
  </TableView>
}


